import Button from "../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {locationIcons} from "../../../../utils/constants";
import "./Locations.scss"
import UploadImageComp from "../../../../components/Upload/UploadImageComp";
import {toast} from "react-toastify";
import axios from "axios";
import errorParser from "../../../../components/ErrorParser/ErrorParser";
import LoadingComp from "../../../../components/elements/LoadingComp/LoadingComp";
import Selector from "../../../../components/elements/Selector/Selector";

export default function EditLocation() {

    const intl = useIntl();
    const navigate = useNavigate()
    let params = useParams();
    const jwt = localStorage.getItem('jwt')

    const [title, setTitle] = useState('')
    const [capacity, setCapacity] = useState(0)
    const [color, setColor] = useState('#000')

    const [useImage, setUseImage] = useState(false)
    const [icon, setIcon] = useState('1.svg')
    const [newImage, setNewImage] = useState(null)
    const [imageUrl, setImageUrl] = useState('')
    const [type, setType] = useState('')

    const [saveLoading, setSaveLoading] = useState(false)
    const [loading, setLoading] = useState(true)
    const {context} = useOutletContext()


    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/locations/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setTitle(response.data.title)
                setType(response.data.type)
                setCapacity(response.data.capacity)
                setColor(response.data.color)

                if (response.data.useImage){
                    setIcon(null)
                }else {
                    setIcon(response.data.icon)
                }
                setUseImage(response.data.useImage)

                if(response.data.image) {
                    setImageUrl(process.env.REACT_APP_API + response.data.image.url)
                }

                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const save = async (e) => {
        e.preventDefault();

        setSaveLoading(true)
        let formData = new FormData()
        if(newImage) {
            formData.append('image', newImage)
        }
        formData.append('data', JSON.stringify({
            title: title,
            capacity: capacity,
            useImage: useImage,
            color: color,
            type,
            icon: !useImage ? icon : null
        }))

        await axios.put(process.env.REACT_APP_API + '/locations/' + params.id, formData, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                navigate(-1)
            })
            .catch(err => {
                errorParser(err, intl)
            })


        setSaveLoading(false)
    }

    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="container">

            <div className={"row"}>
                <div className={"col-12"}>
                    <h1 className={"container-title"}>{intl.formatMessage({id: 'settings.menu.locations'})}</h1>
                </div>
                <div className={"col-12"}>
        <div className="card">

            <div className={"header"}><p>{intl.formatMessage({id: 'settings.locations.edit_location'})}</p></div>

            <form onSubmit={(e) => save(e)}>
            <div className={"content"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className={"form-control"}>
                            <div className={"form-label"}>{intl.formatMessage({id: 'settings.locations.title'})}<span
                                className={"form-required"}>*</span></div>
                            <input type={"text"} className={"form-input"}
                                   value={title} onChange={(e) => {

                                context.setContentUpdated(true)
                                       setTitle(e.target.value)
                            }}/>
                        </div>
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <div className={"form-control"}>
                            <div className={"form-label"}>{intl.formatMessage({id: 'settings.locations.capacity'})}<span
                                className={"form-required"}>*</span></div>
                            <input type={"number"} min={0} max={100000} step={1} className={"form-input"}
                                   onFocus={(event) => event.target.select()}
                                   value={capacity} onChange={(e) => {

                                context.setContentUpdated(true)
                                       setCapacity(e.target.value)
                            }}/>
                        </div>
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <div className={"form-control"}>
                            <div className={"form-label"}>{intl.formatMessage({id: 'settings.locations.type'})}<span
                                className={"form-required"}>*</span></div>
                            <Selector
                                key={1}
                                required
                                options={[{
                                    value: 'salon',
                                    label: intl.formatMessage({id: 'settings.locations.type.salon'})
                                },{
                                    value: 'catering',
                                    label: intl.formatMessage({id: 'settings.locations.type.catering'})
                                }]}
                                disabled
                                value={type}
                                onChange={(option) => setType(option.value)}
                                isSearchable={true}
                                isOptionDisabled={(option) => option.disabled}
                            />
                        </div>
                    </div>
                    <div className={"col-12 col-md-12"}>
                        <div className={"form-control"}>
                            <div className={"form-label"}>{intl.formatMessage({id: 'settings.locations.color'})}<span
                                className={"form-required"}>*</span></div>
                            <input type={"color"} style={{maxWidth: '56px'}} step={1} className={"form-input"} required
                                   value={color} onChange={(e) => {
                                context.setContentUpdated(true)
                                       setColor(e.target.value)
                            }}/>
                        </div>
                    </div>
                    <div className={"col-12"}>

                        <div className={"form-label"}>{intl.formatMessage({id: 'settings.locations.image'})}</div>
                        <div className={"tab-switch with-content"}>
                            <div className={"tab " + (!useImage ? "active" : "")} onClick={() => {

                                context.setContentUpdated(true)
                                setUseImage(false)
                            }}>
                                {intl.formatMessage({id: 'settings.locations.choose_icon'})}
                            </div>
                            <div className={"tab " + (useImage ? "active" : "")} onClick={() => {
                                context.setContentUpdated(true)
                                setUseImage(true)
                            }}>
                                {intl.formatMessage({id: 'settings.locations.upload_image'})}
                            </div>
                        </div>
                        <div className={"tab-content p-2"}>
                            {
                                useImage ?
                                    <UploadImageComp
                                        image={newImage}
                                        setImage={setNewImage}
                                        imageUrl={imageUrl}
                                        setImageUrl={setImageUrl}
                                        className={"p-3"}
                                    />
                                    :
                                    <div className={"location-icon-picker"}>
                                        {
                                            locationIcons.map((iconItem,i) => (
                                                <div key={i}
                                                     className={"location-icon " + (iconItem === icon ? "active" : "")}
                                                     onClick={() => {
                                                         context.setContentUpdated(true)
                                                         setIcon(iconItem)
                                                     }}
                                                >
                                                    <img src={"/images/locations_icons/" + iconItem} alt={""}/>
                                                </div>
                                            ))
                                        }

                                    </div>
                            }
                        </div>

                    </div>


                </div>
            </div>

            <div className={"footer"}>
                <div className={"row"}>
                    <div className={"col-12 col-md-6"}>
                        <Button
                            className={"btn-light mt-2"}
                            icon={"fa-solid fa-chevron-left"}
                            value={intl.formatMessage({id: 'general.buttons.back'})}
                            onClick={() => {
                                context.setLeavePage(true)
                                context.setNextLink('/locations')
                            }}
                        />
                    </div>
                    <div className={"col-12 col-md-6 d-flex"}>
                        <Button
                            className={"btn-secondary mt-2 ms-auto"}
                            icon={"fa-regular fa-floppy-disk"}
                            value={intl.formatMessage({id: 'general.buttons.save'})}
                            disabled={saveLoading}
                            loading={saveLoading}
                            type={'submit'}
                        />
                    </div>
                </div>
            </div>
            </form>
        </div>
                </div>
            </div>
        </div>
    );
}

